export const shortId = () => Math.random().toString(36).substring(2, 15)
export const generateId = () => shortId() + shortId()
